import { Expose } from "class-transformer";
import { EmployeeDocumentReviewStatusEnum } from "@/core/features/employee-documents/employee-document-review-status.enum";

export class ReviewEmployeeDocumentDto {
  @Expose()
  reviewStatus: EmployeeDocumentReviewStatusEnum;

  @Expose()
  reviewMessage?: string;
}
